/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


(function(){
	'use strict';

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		/* Search Form functionality
		 * The click functionality involves three different actions,
		 * depending on conditions the various clicks provide.
		 */
		var searchOpen = document.querySelectorAll( '.search-form__button--open' );
		var searchClose = document.querySelectorAll( '.search-form__button--close' );

		if ( searchOpen ) {
			for (var i=0; searchOpen.length > i; i++) {
				searchOpen[i].addEventListener( 'click', function() {
					this.parentElement.classList.add( 'search-form--active' );
					this.parentElement.querySelector('.site_search__field').focus();
		
					// Hide the search bar after click out of it
					document.getElementById( 'content' ).addEventListener( 'click', function() {
						if ( this.parentElement.classList.contains( 'search-form--active' ) ) {
							this.parentElement.classList.remove( 'search-form--active' );
						}
					});
				});
			}
			
			for (var i=0; searchClose.length > i; i++) {
				searchClose[i].addEventListener( 'click', function() {
					this.parentElement.classList.remove( 'search-form--active' );
				});
			}
		}


		/**
		 * Linkclicker
		 * 
		 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
		 * Note: the container should have only one link.
		 */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for ( var i = 0; linkclickers.length > i; i++ ) {
			var linkclicker = linkclickers[i];

			linkclicker.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.querySelector('a');
				var linkPath = link.getAttribute('href');
				
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}


		/**
		 * Force external links/PDFs to open in a new tab.
		 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		 * 2019-07-11 - TA
		 */
		function link_is_external(link_element) {
			return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
		}

		var anchorElements = document.getElementsByTagName('a');
		for ( let anchorElement of anchorElements ) {

			if ( link_is_external( anchorElement ) ) {
				anchorElement.setAttribute( 'target','_blank' );
				anchorElement.setAttribute( 'rel','noopener' );

				// Add assistive text to alert of external links
				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
				var assistiveTextContainer = document.createElement( 'span' );
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild( assistiveTextContainer.firstChild );
			}
		}

		/**
		 * Detects if element is in viewport and add class
		 */
		function observeElements(elements, className, options = {}) {
			// Create an Intersection Observer
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add(className); // Add class when in view
					}
				});
			}, options);
			
			// Observe each element in the NodeList
			elements.forEach((element) => observer.observe(element));
		}

		const elements = document.querySelectorAll('.animated'); // Elements to observe
		const options = {
			root: null, // Default: viewport
			rootMargin: '0px 0px 0px 0px', // Adjust based on layout
			threshold: 0.2, // Trigger when 20% of the element is visible
		};
		observeElements(elements, 'in-view', options); // Start observing
        
        /**
         * Collapsibles
         */
        var collapsibleHeaders = document.querySelectorAll(
            ".collapsible-row__header"
        );

        if (collapsibleHeaders) {
            for (var i = 0; collapsibleHeaders.length > i; i++) {
                var collapsibleHeader = collapsibleHeaders[i];

                collapsibleHeader.addEventListener("click", function () {
                    this.classList.toggle("active");
                    var textHeight = this.parentElement.nextElementSibling.querySelector(
                        ".collapsible-row__content"
                    ).clientHeight; // Get height of text within collapsible row
                    var rowHeight = this.parentElement.nextElementSibling.clientHeight; // Get height of row to see if it's expanded

                    if (rowHeight == 0) {
                        // If collapsible content is collapsed...
                        this.parentElement.nextElementSibling.style.height = textHeight + 1 + "px";
                    } else {
                        this.parentElement.nextElementSibling.style.height = 0 + "px";
                    }

                    if (this.parentNode.parentNode.classList.contains("expanded")) {
                        this.setAttribute("aria-expanded", "true");
                    } else {
                        this.setAttribute("aria-expanded", "false");
                    }
                });
            }
        }
        
        // Check if any images have "Contain" set and set the containing div height to 
        // the height of the layout, which must be set to something when the image is 
        // set to position: absolute.
        const containEls = document.querySelectorAll('.contain-img');
        if (containEls.length) {
            for (let el of containEls) {
                const parent = el.parentElement.parentElement;
                const parentHeight = parent.offsetHeight;
                el.style.height = parentHeight + 'px';
            }
        }

		// Prevent clicks on blank link nav items
		var passiveLinks = document.querySelectorAll('.passtive-link');

		passiveLinks.forEach(element => {
			element.addEventListener('click', function () {
				this.querySelector('a').preventDefault();
			});
		});
        
	}); // End of load function
	

	// Include ready events here
	window.addEventListener( 'DOMContentLoaded', function() {
		
	});


	/**
	 * Cookie Popup scripts
	 */
	var popUp		= document.getElementById('cookie-popup');
	var popUpMain	= document.getElementById('popup-main');

	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie( "accepts-cookie", "accepts-cookie-set", 365 );
	}

	document.getElementById('accept-button').addEventListener( 'click', function() {
		accept();
	});

	var cookie = readCookie( 'accepts-cookie' );
	// If user already has accepted cookies, don't show popup
	if ( cookie == 'accepts-cookie-set' ) {
		popUp.style.display = "none";
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
	}
})();
